import { TableCell, TableCellClassKey, TableCellProps, TableSortLabel } from '@material-ui/core';
import * as React from 'react';
import { Dispatch, SetStateAction, ThHTMLAttributes, useCallback } from 'react';
import { GetProjectsCommandGq } from '../../../../graphql/projects/queries/useGetProjectsGq';
import VoxelTableHeadCell from '../../../voxel/Tables/VoxelTableHeadCell';

export interface ProjectHeaderCellProps
  extends Pick<ThHTMLAttributes<HTMLTableCellElement>, 'align'> {
  setFilterState: Dispatch<SetStateAction<GetProjectsCommandGq>>;
  currentSortBy: string;
  currentDirection: 'asc' | 'desc';
  sortBy: string;
  children?: React.ReactNode;
  className?: string;
}

const ProjectHeaderCell: React.FC<ProjectHeaderCellProps> = ({
  setFilterState,
  currentSortBy,
  sortBy,
  children,
  currentDirection,
  align = 'left',
  className,
}) => {
  const handleSort = useCallback(() => {
    // We can use the prev state within the state dispatcher
    setFilterState((prev) => {
      // Default to ASC sort if other key was selected
      if (currentSortBy !== sortBy) {
        return {
          ...prev,
          sortBy,
          sortDirection: 'asc',
        };
      }

      // Other wise just flip the direction
      return {
        ...prev,
        sortBy,
        sortDirection: prev.sortDirection === 'asc' ? 'desc' : 'asc',
      };
    });
  }, [sortBy, currentSortBy]);

  return (
    <VoxelTableHeadCell size='lg' align={align} className={className}>
      <TableSortLabel
        active={currentSortBy === sortBy}
        direction={currentDirection}
        onClick={handleSort}
      >
        {children}
      </TableSortLabel>
    </VoxelTableHeadCell>
  );
};

export default ProjectHeaderCell;
